import React from 'react';
import PropTypes from 'prop-types';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';

/**
 * Used to easily create a context menu.
 */
export default class TooltipMenu extends React.PureComponent {
  static propTypes = {
    // what will be rendered in the menu
    menu: PropTypes.element,
    // what will be rendered on the page (consider a primary button)
    children: PropTypes.element,
    // callback invoked when the menu is displayed
    onShowMenu: PropTypes.func,
    // classname for the menu wrapper
    className: PropTypes.string,
  };

  render() {
    const {menu, children, onShowMenu, className} = this.props;
    return (
      <GenericTooltip
        clickBehavior
        tooltip={menu}
        children={children}
        onOpen={onShowMenu}
        className={className}
      />
    );
  }
}
